import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InviteEasyApplyStorageService {
  private keyStorage: string = 'hashInviteEasyApply';

  sessionStorage = sessionStorage;

  getInvite(): string | null {
    return this.sessionStorage.getItem(this.keyStorage);
  }

  setInvite(hashInvite: string): void {
    this.sessionStorage.setItem(this.keyStorage, hashInvite);
  }

  removeInvite(): void {
    this.sessionStorage.removeItem(this.keyStorage);
  }
}
